export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_06-445680ac31c976298a875bfae1a4b46b.jpg";